// extracted by mini-css-extract-plugin
export default {"homeButton":"NobleVillage_homeButton__OssZJ","mapButton":"NobleVillage_mapButton__Aj6KX","button":"NobleVillage_button__JkaN8"};